import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IconNavbarHomeActive } from "../../assets/icons/IconNavbarHomeActive";
import { Breadcrumbs, Container, Contents, SectionInfo, BlogCardsGrid, Sidebar, FeaturedCardWrapper, PaginationContainer } from "./styles";
import { contentsLink } from "../../components/LpFooter";
import BlogCard from "../../components/BlogCard";
import { GreenButton } from "../../utils/styles";
import { blogText } from "../../utils/blogText";
import BlogMiniCard from "../../components/BlogMiniCard";
import Pagination from "../../components/Pagination";

export default function BlogPage() {
  const blogContent = blogText.get("blog");
  const link = "https://app.zedasorte.com.br";
  const actionButtons = [
    { label: "Mega-sena", link: link },
    { label: "Quina", link: link },
    { label: "Lotofácil", link: link },
    { label: "Lotomania", link: link },
    { label: "Dupla Sena", link: link },
  ];

  const [news, setNews] = useState([]);
  const [newsHighlight, setNewsHighlight] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const getHighlight = page === 1;
    setLoading(true);
    fetch(`https://imbilcrbn8.execute-api.us-east-1.amazonaws.com/Prod/api/v1/blog?page=${page}&perPage=${getHighlight ? 7 : 6}&category=&allStatus=true`)
      .then(res => res.json())
      .then(data => {
        setNews(data.data || []);
        setTotalPages(data.totalPages || 1);
        setLoading(false);
        if (getHighlight) setNewsHighlight(data.data.find(item => item.isHighlight) || null);
      })
      .catch(() => setLoading(false));
  }, [page]);

  return (
    <Container>
      <Breadcrumbs>
        <IconNavbarHomeActive />
        <span>/</span>
        <Link to="/">Home</Link>
        <span>/</span>
        <Link to={ contentsLink }>Blog</Link>
      </Breadcrumbs>

      <SectionInfo id="info">
        <div className="text">
          <h3>{ blogContent.title }</h3>
          <p>{ blogContent.description }</p>
        </div>
        <div className="buttonCenter">
          { actionButtons.map((btn, idx) => (
            <Link to={ btn.link } key={ idx }>
              <GreenButton className="marginBottom">
                { btn.label }
              </GreenButton>
            </Link>
          )) }
        </div>
      </SectionInfo>
      <Contents>
        <BlogCardsGrid>
          { loading ? (
            // <div>Carregando...</div>\
            <></>
          ) : (
            <>
              { newsHighlight && (
                <FeaturedCardWrapper>
                  <BlogCard
                    content={ {
                      postId: newsHighlight.postId,
                      slug: newsHighlight.slug,
                      imageUrl: newsHighlight.imageUrl,
                      createdAt: newsHighlight.createdAt,
                      title: newsHighlight.title,
                      description: newsHighlight.description,
                      highlight: newsHighlight.isHighlight
                    } }
                  />
                </FeaturedCardWrapper>
              ) }
              { news.filter(item => !item.isHighlight).map((item, idx) => (
                <BlogCard
                  key={ item.postId }
                  content={ {
                    postId: item.postId,
                    slug: item.slug,
                    imageUrl: item.imageUrl,
                    createdAt: item.createdAt,
                    title: item.title,
                    description: item.description,
                    highlight: item.isHighlight
                  } }
                />
              )) }
            </>
          ) }
          <PaginationContainer>
            <Pagination
              page={ page }
              totalPages={ totalPages }
              onChange={ setPage }
            />
          </PaginationContainer>
        </BlogCardsGrid>
        <Sidebar>
          <BlogMiniCard
            icon={ "📱" }
            title="Siga no Instagram"
            description="Acompanhe dicas diárias, resultados em tempo real e histórias inspiradoras no nosso Instagram oficial."
            buttonLabel="@ozedasorteoficial"
            buttonLink="https://www.instagram.com/ozedasorteoficial/"
          />
          <BlogMiniCard
            icon={ "🎯" }
            title="Comece a Jogar Hoje"
            description="Não perca mais tempo indo até a lotérica. Jogue de casa com total segurança!"
            buttonLabel="Fazer Meu Primeiro Jogo"
            buttonLink={ link }
          />
        </Sidebar>
      </Contents>
    </Container>
  );
}
